import React, { Component } from 'react'
import { HBBModal } from '../../../Modal/Components'
import { NewJoineeResponderModalLayout } from '../NewJoineeResponderModalLayout'

class NewJoineeResponder extends Component {
    constructor() {
        super()
        this.state = {
            isImportNewJoineeResponderModalOpened: false,
        }
    }
    openImportNewJoineeResponderModal = () => {
        this.setState({ isImportNewJoineeResponderModalOpened: true })
    }

    controlOpenCloseOfModal = (status) => {
       this.setState({ isImportNewJoineeResponderModalOpened: status })
    }

    refreshOrderList = () => {
        this.props.refreshOrderList()
    }

    render() {
        let modalComponent = null

        if (this.state.isImportNewJoineeResponderModalOpened) {
            modalComponent =
                <HBBModal>
                    <NewJoineeResponderModalLayout data={this.props.data}
                        closeModal={this.controlOpenCloseOfModal}
                        />
                </HBBModal>
        }
        return (
            <div>
                {modalComponent}
                <button
                    className="btn btn-primary button-custom"
                     onClick={(e) => {
                        e.preventDefault()
                        this.openImportNewJoineeResponderModal()
                    }}>
                    Respond
                </button>
            </div>
        )
    }
}

export default NewJoineeResponder


// WEBPACK FOOTER //
// ./src/modules/New Joinee/Components/ActionButtons/NewJoineeResponder.js